module.exports = __webpack_public_path__ + "img/EEE04AFE-33FB-4A29-9BD9-D7A1995B48E7.b97121c7.jpg";